import queryString from 'query-string';
import mapValues from 'lodash/mapValues';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

const STRING_VALUES = [
	'sortBy',
	'collection',
];

export default location => {
	const pathname = location.pathname.replace(/\/$/, ''); // remove trailing slash
	const productTypeParts = pathname.split('/shop/');
	const collectionParts = pathname.split('/collections/');
	const query = queryString.parse(location.search, {arrayFormat: 'comma'});

	// Set product type
	if (productTypeParts[1]) {
		query.productType = productTypeParts[1];
	}

	// Set collection
	if (collectionParts[1]) {
		query.collection = collectionParts[1];
	}
	
	return mapValues(query, (value, key) => {
		if (STRING_VALUES.indexOf(key) > -1) return value;
		if (isArray(value)) return value;
		if (isString(value)) return value.split(',');
		if (isNumber(value)) return value;

		return value;
	});
};